export const GOOGLE_CALENDAR_ICON_SRC =
  "/assets/calendar_connections/google_calendar.svg";
export const MS_CALENDAR_ICON_SRC =
  "/assets/calendar_connections/ms_calendar.svg";

const CALENDAR_PROVIDER_ICONS: Record<string, { src: string; alt: string }> = {
  google: { src: GOOGLE_CALENDAR_ICON_SRC, alt: "Google Calendar" },
  microsoft: { src: MS_CALENDAR_ICON_SRC, alt: "Microsoft Calendar" }
};

export const getCalendarProviderIcon = (provider: string) =>
  CALENDAR_PROVIDER_ICONS[provider] ?? CALENDAR_PROVIDER_ICONS.google;
